import { IAppFile } from './app-file.interface';
import { IAppId } from './app-id.interface';
import { IDictionary } from './dictionary.interface';
import { AppStatus } from './enums/app-status.enum';
import { PaymentModel } from './enums/payment-model.enum';
import { IAppCategory } from './IAppCategory.interface';
import { IVersionData } from './IVersionData';

export interface IAppVersion {
  app?: IAppId;
  id?: string;
  version?: string;
  appName?: string;
  status?: AppStatus;
  description?: string;
  developerId?: string;
  numberOfDownloads?: number;
  totalSales?: number;
  revenue?: number;
  numberOfCurrentInstallations?: number;
  shortDescription?: string;
  apks?: IAppFile[];
  screenshots?: IAppFile[];
  newVersionAllowed?: boolean;
  appIcons?: IAppFile[];
  qsaReports?: IAppFile[];
  userGuides?: IAppFile[];
  privacyPolicy?: string;
  supportContactInfo?: string;
  pricingModel?: string;
  paymentModel?: PaymentModel;
  isDefaultApp?: boolean;
  //inAppPayments?: boolean;
  minimumPrice?: number;
  categories?: IAppCategory[];
  modelFamilies?: IDictionary[];
  deviceFamilies?: IDictionary[];
  modelFamiliesWithDeviceModels?: {
    [modelFamilyValue: string]: string[];
  };
  appSupportEmail?: string;
  appSupportWebsite?: string;
  appSupportContactNumber?: string;
  appTermOfUse?: string;
  createdDate?: Date;
  updatedDate?: Date;
  testingInstructions?: string;
  modifiedBy?: string;
  appVersions?: IVersionData[];
  releaseNotes?: string;
  hasAssignments?: boolean;
}
